module.exports = __webpack_public_path__ + "img/fi-rr-play-alt.a825aa8e.svg";